import { render } from "./BtngroupDouble.vue?vue&type=template&id=5b9900a6&scoped=true"
import script from "./BtngroupDouble.vue?vue&type=script&lang=js"
export * from "./BtngroupDouble.vue?vue&type=script&lang=js"

import "./BtngroupDouble.vue?vue&type=style&index=0&id=5b9900a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9900a6"]])

export default __exports__